import { z } from 'zod/v4';

/** NotificationSubscriptionReceiver */
export const NotificationSubscriptionReceiverDTO = z.object({
  id: z.string(),
  mute_time_interval_name: z.string(),
  active_time_interval_name: z.string(),
  name: z.string(),
  receiver_senders: z.array(
    z.object({
      sender_name: z.string(),
      active: z.boolean(),
      address: z.string(),
      extend_data: z.record(z.string(), z.any()),
      sender_active: z.boolean(),
    }),
  ),
});
export type NotificationSubscriptionReceiver = z.infer<
  typeof NotificationSubscriptionReceiverDTO
>;

/** CreateNotificationSubscriptionReceiverDTO = Omit<..., 'id'> */
export const CreateNotificationSubscriptionReceiverDTO =
  NotificationSubscriptionReceiverDTO.omit({ id: true });
export type CreateNotificationSubscriptionReceiver = z.infer<
  typeof CreateNotificationSubscriptionReceiverDTO
>;

/** UpdateNotificationSubscriptionReceiverDTO = Omit<..., 'id'> */
export const UpdateNotificationSubscriptionReceiverDTO =
  NotificationSubscriptionReceiverDTO.omit({ id: true });
export type UpdateNotificationSubscriptionReceiver = z.infer<
  typeof UpdateNotificationSubscriptionReceiverDTO
>;